const SUFFIX_MAP: Record<string, string> = {
  street: "st",
  road: "rd",
  avenue: "ave",
  drive: "dr",
  lane: "ln",
  court: "ct",
  boulevard: "blvd",
  place: "pl",
  terrace: "ter",
  circle: "cir",
  parkway: "pkwy",
  trail: "trl",
  highway: "hwy",
  square: "sq",
  plaza: "plz",
  park: "pk",
  extension: "ext",
  north: "n",
  south: "s",
  east: "e",
  west: "w",
  northeast: "ne",
  northwest: "nw",
  southeast: "se",
  southwest: "sw",
  apartment: "apt",
  suite: "ste",
  unit: "unit",
  number: "no",
};
const SORTED_KEYS = Object.keys(SUFFIX_MAP).sort((a, b) => b.length - a.length);
const SUFFIX_REGEX = new RegExp(`\\b(${SORTED_KEYS.join("|")})\\b`, "gi");

// Drop the ordinal suffix on numbered streets so "62nd" compares equal to "62"
const ORDINAL_REGEX = /\b(\d+)(st|nd|rd|th)\b/gi;

// Length of the postal code prefix to compare (ignore the +4 ZIP extension).
export const ZIP_CODE_LENGTH = 5;

export const first5Digits = (val?: string | null) => val?.replace(/\D/g, "").slice(0, ZIP_CODE_LENGTH) ?? "";

export function formatPostalCode(val?: string | null): string {
  const digits = val?.replace(/\D/g, "") ?? "";

  if (digits.length === 9) {
    return `${digits.slice(0, ZIP_CODE_LENGTH)}-${digits.slice(ZIP_CODE_LENGTH)}`;
  }

  return digits.slice(0, ZIP_CODE_LENGTH);
}

/** Matches PO Box, P.O. Box, P O Box, POB, Post Office Box — all case-insensitive. */
const PO_BOX_REGEX = /^\s*(?:p\.?\s*o\.?\s*b(?:ox)?|post\s+office\s+box)\b/i;

export function isPoBoxAddress(line1: string | null | undefined): boolean {
  return !!line1 && PO_BOX_REGEX.test(line1);
}

export function normalizeAddressForComparison(addr: string | null | undefined): string {
  if (!addr) return "";

  return addr
    .toLowerCase()
    .replace(/[^\w\s]/g, "")
    .replace(ORDINAL_REGEX, "$1")
    .replace(SUFFIX_REGEX, (matched) => SUFFIX_MAP[matched.toLowerCase()] || matched)
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Normalize a secondary address line while treating common unit designators as equivalent.
 * For example, "#412", "Suite 412", and "ste 412" all normalize to "412".
 */
export function normalizeAddressLine2ForComparison(line2: string | null | undefined): string {
  return normalizeAddressForComparison(line2).replace(/^(?:apt|ste|unit|no)\s+/, "");
}
